import { Pill } from '@design-system';
import { useTranslation } from 'next-i18next';
import { FC, ReactNode } from 'react';
import { render } from 'storyblok-rich-text-react-renderer-ts';

import { isStoryblokRichTextPresent } from '../../utils/renderStoryblokRichText';
import { PreviewItem } from '../../utils/storyblok/stories';
import { Image } from '../Image';

const paragraph = (children: ReactNode) => <span>{children}</span>;

interface Props {
  item: PreviewItem;
}

export const GlossaryReference: FC<Props> = ({ item }) => {
  const { t } = useTranslation('common');

  const tag = (value?: string) => {
    if (value) {
      return <Pill label={value} />;
    }
    return null;
  };

  return (
    <div className="flex w-full columns-2 gap-x-3 md:gap-x-6">
      <div className="flex flex-grow flex-col group-hover:text-neutral-4 md:w-full">
        {item.tag && (
          <div className="mb-3 flex items-start md:hidden">
            {tag(t(item.tag))}
          </div>
        )}
        <h3 className="font-bold transition-colors duration-300">
          {item.title}
        </h3>
        {isStoryblokRichTextPresent(item.intro) && (
          <p className="line-clamp-3 transition-colors duration-300">
            {render(item.intro, { nodeResolvers: { paragraph } })}
          </p>
        )}
      </div>
      <div className="flex justify-between gap-x-6 md:w-full">
        <div className="hidden items-start md:flex">
          {item.tag && tag(t(item.tag))}
        </div>
        <div className="w-14 lg:w-12">
          {item.image && (
            <Image
              alt={item.title || ''}
              className="overflow-hidden rounded-sm"
              hoverEffect
              src={item.image}
              width={64}
            />
          )}
        </div>
      </div>
    </div>
  );
};
